module.exports = __webpack_public_path__ + "img/review3.b24da6d6.png";